<script>
  import session from '../../../lib/session';
  import APIClient from '../../../state-charts/api-client';
  import router from '../../../lib/router';
  import { show_message } from '../../../lib/flash';
  import { t9n } from '../../../lib/translate';
  import { TS } from '../../../config/translation-keys.js';

  export let table_data;
  export let headers;
  export let searched;
  export let current_chip;
  export let current_page;
  export let number_of_pages;
  export let filters;
  export let show_filters;
  export let hide = false;

  let no_result;
  let error_order_apply_not_approved;

  const data_row_id = i => {
    return 'u' + i;
  };

  const open_chat = async (order, row) => {
    if(is_chat_exists(row)) {
      if ($session.user.registered_merchants.find(rm => rm.uuid === $session.merchant.merchant_uuid).status.apply === 'approved') {
        let result = await APIClient.get_order({ order_uuid: order });
        let user_role = $session.user.last_role;
        let partner_id;
        if (user_role === 'worker') partner_id = result.orderer.basic_profile.id;
        else {
          partner_id = result.worker.basic_profile.id;
        }
        router.navigate(`chats/${order}/partner/${partner_id}`);
        searched = '';
      } else {
        show_message(error_order_apply_not_approved, 'error');
      }
    }


  };

  const open_order = order => {
    let url = `order-details?id=${order}&group=${current_chip}&page=${current_page}`;
    if (!!show_filters) {
      url += '&filters=true';
      for (let [key, value] of Object.entries(filters)) {
        if (!!value) {
          url += `&${key}=${value}`;
        }
      }
    }
    router.navigate(url);
    searched = '';
  };

  const is_chat_exists = (row) => {

    if($session.role === "worker"){
      if(current_chip === 0){
        return true;
      } else {
        return !(row.chat.worker === null)
      }
    } else {
      return !(row.chat.worker === null)
    }

  }

  const translate_texts = () => {
    no_result = t9n(TS.TABLE_NO_RESULT);
    error_order_apply_not_approved = t9n(TS.CHAT_ORDER_APPLY_NOT_APPROVED);
  };

  $: if (!!$session) translate_texts();
</script>

<tbody class='mdc-data-table__content fade-in'>
{#if !!table_data}
  {#each table_data as table, k}
    {#each table as row, i}
      <tr data-row-id={data_row_id(i)} class='mdc-data-table__row fade-in'
          class:hide_cancelled={hide && row.status === 'order_status_cancelled_by_admin' || hide && row.status === 'order_status_cancelled_by_orderer' || hide && row.status === 'order_status_cancelled_by_worker'}>
        {#each Object.keys(row) as cell, j}
          {#if cell !== 'type'}
            {#if headers[j].show === true}
              {#if headers[j].type === 'icon'}
                <td
                  class=' mdc-data-table__cell class:data-heading={Object.values(row)[j]}'
                  class:status-bg-cancelled={row.status === 'order_status_cancelled_by_admin' || row.status === 'order_status_cancelled_by_orderer' || row.status === 'order_status_cancelled_by_worker'}
                  class:status-bg-notapprv={row.status === 'order_status_not_approved'}
                  class:status-bg-payment-fail={row.payment.payment_status === 'payment_status_payment_needed' && row.status === 'order_status_delivered' && $session.user.last_role === 'orderer'}
                  style='white-space: pre-line; position: relative'
                  on:click={async () => { await open_chat(row.id, row) } }>
                  {#if Object.values(row)[j].icon !== 'chat'}
                    <a href={Object.values(row)[j].href}>
                      <i
                        class='material-icons'
                        class:icon-color-payment-fail={Object.values(row)[j].icon === 'error'}>
                        {Object.values(row)[j].icon}
                      </i>
                    </a>
                  {:else}
                    {#if is_chat_exists(row) }
                      <i class='material-icons grow'>
                        {Object.values(row)[j].icon}
                      </i>
                      {/if}
                  {/if}
                </td>
              {:else}
                <td
                  class=' mdc-data-table__cell class:data-heading={Object.values(row)[j]}'
                  class:status-bg-cancelled={row.status === 'order_status_cancelled_by_admin' || row.status === 'order_status_cancelled_by_orderer' || row.status === 'order_status_cancelled_by_worker'}
                  class:status-bg-notapprv={row.status === 'order_status_not_approved'}
                  class:status-bg-payment-fail={row.payment.payment_status === 'payment_status_payment_needed' && row.status === 'order_status_delivered' && $session.user.last_role === 'orderer'}
                  style='white-space: pre-line;'
                  on:click={() => open_order(row.id)}>
                  {#if headers[j].type === 'image' && !Object.values(row)[j].name}
                    <img
                      src={Object.values(row)[j].url}
                      height='70'
                      width='70'
                      alt='avatar' />
                  {:else if headers[j].type === 'image' && Object.values(row)[j].name && $session.user.last_role === 'orderer'}
                    <img
                      src={Object.values(row)[j].url}
                      height='60'
                      width='60'
                      alt='avatar' />
                    <div style='margin-top: -6px; margin-bottom: 6px;'>
                      {Object.values(row)[j].name}
                    </div>
                  {:else if headers[j].type === 'image' && Object.values(row)[j].name && $session.user.last_role === 'worker'}
                    <img
                      src={Object.values(row)[j].url}
                      height='60'
                      width='60'
                      alt='avatar' />
                  {:else if headers[j].type === 'price'}
                    {#if !Object.values(row)[12]}
                      {Object.values(row)[j]}
                    {/if}
                  {:else if headers[j].type === 'string'}
                    {#if j === 1}
                      <p style='margin-top: 0px;'>
                        {#if Object.values(row)[j].desc.length < 20}
                          {Object.values(row)[j].desc}
                        {:else}
                          {Object.values(row)[j].desc.substring(0, 40)}...
                        {/if}
                      </p>
                      <p style='font-style: italic; margin-top: -15px;'>
                        {Object.values(row)[j].based}
                      </p>
                      <p style='font-style: italic; margin-top: -15px;'>
                        {Object.values(row)[j].teams}
                      </p>
                    {:else if j === 5}
                      {#if Object.values(row)[1].is_virtual}
                        {t9n(TS.ORDERS_IS_VIRTUAL)}
                      {:else}{Object.values(row)[j]}{/if}
                    {:else}
                      {#if Object.values(row)[j].length > 10}
                        <p class='substring'>{Object.values(row)[j]}</p>
                      {:else}
                        <p>{Object.values(row)[j]}</p>
                      {/if}
                    {/if}
                  {:else if headers[j].type === 'rating'}
                    {#if $session.user.last_role === 'orderer'}
                      <i class='material-icons'>
                        {Object.values(row)[j].icon_top}
                      </i>
                    {:else}
                      <i class='material-icons'>
                        {Object.values(row)[j].icon_bottom}
                      </i>
                    {/if}
                  {:else if headers[j].type === 'bool'}
                    {#if Boolean(Object.values(row)[j]) === true}
                      <i class='material-icons'>done</i>
                    {/if}
                  {/if}
                </td>
              {/if}
            {/if}
          {/if}
        {/each}
      </tr>
    {/each}
  {/each}
{/if}

{#if number_of_pages === 0}
  <div class='no-result fade-in'>{no_result}</div>
{/if}
</tbody>

<style>
    .icon-color-payment-fail {
        color: #ff0000 !important;
    }

    .no-result {
        padding: 30px;
    }

    .material-icons {
        color: var(--mdc-theme-primary);
    }

    .grow {
        transition: all 0.2s ease-in-out;
    }

    .grow:hover {
        transform: scale(1.25);
    }

    .status-bg-cancelled {
        background-color: var(--order-status-cancelled-by-orderer);
    }

    .status-bg-notapprv {
        background-color: var(--order-status-not-approved);
    }

    .status-bg-payment-fail {
        background-color: var(--order-status-not-approved) !important;
    }

    .mdc-data-table__row {
        z-index: 2;
    }

    .substring {
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        display: inline-block;
    }

    img {
        border-radius: 50%;
        margin-left: 15px;
        margin-top: 10px;
        margin-bottom: 6px;
    }

    .hide_cancelled {
        display: none;
    }

    /* Mobile Mode
     *******************************************************/
    @media (max-width: 768px) {

        .mdc-data-table__cell {
            display: block;
            height: 100%;
        }

        .mdc-data-table__row {
            display: block;
        }

        .mdc-data-table__cell:first-child {
            text-align: center;
        }

        .mdc-data-table__cell:before {
            content: attr(data-heading);
        }

        td.mdc-data-table__cell i {
            margin-left: 50%;
        }

        .hide_cancelled {
            display: none;
        }
    }
</style>